export const SECTION_MARGIN = 4;

// Modal
export const MODAL_UPLOAD_DOCUMENT = "CANCELLATION_MODAL_UPLOAD_DOCUMENT";
export const MODAL_UPLOAD_ATTACHMENT = "MODAL_UPLOAD_ATTACHMENT";
